// extracted by mini-css-extract-plugin
module.exports = {"pageRoot":"styles_pageRoot__W16IZ","feedback":"styles_feedback___GuBy"};